import PropTypes from 'prop-types';

import { Bun, Burger, Wrapper, Btn, Label } from './styles';

const BurgerButton = ({
  onClick = () => {},
  isOpen = false,
  duration = '350ms',
  delay = '150ms',
  timingFunction = 'ease',
  height = '2px',
  burgerWidth = '100%',
  bunWidth = '100%',
  color = '#e1251b',
  className = '',
  borderRadius = '25px',
  wrapperHeight = '20px',
  wrapperWidth = '20px',
  children = null,
}) => (
  <Btn
    className={className}
    onClick={() => onClick()}
    aria-label="Menu"
    aria-haspopup="true"
    aria-expanded={isOpen ? 'true' : 'false'}
  >
    {children && <Label>{children}</Label>}
    <Wrapper height={wrapperHeight} width={wrapperWidth}>
      <Bun
        color={color}
        borderRadius={borderRadius}
        height={height}
        width={bunWidth}
        duration={duration}
        delay={delay}
        timingFunction={timingFunction}
        isOpen={isOpen}
      />
      <Burger
        color={color}
        borderRadius={borderRadius}
        height={height}
        width={burgerWidth}
        duration={duration}
        delay={delay}
        timingFunction={timingFunction}
        isOpen={isOpen}
      />
      <Bun
        color={color}
        borderRadius={borderRadius}
        height={height}
        width={bunWidth}
        duration={duration}
        delay={delay}
        timingFunction={timingFunction}
        isOpen={isOpen}
      />
    </Wrapper>
  </Btn>
);

BurgerButton.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.string,
  delay: PropTypes.string,
  timingFunction: PropTypes.string,
  height: PropTypes.string,
  burgerWidth: PropTypes.string,
  bunWidth: PropTypes.string,
  color: PropTypes.string,
  borderRadius: PropTypes.string,
  wrapperHeight: PropTypes.string,
  wrapperWidth: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  className: PropTypes.string,
};

export default BurgerButton;
